import React, { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import PropTypes from "prop-types";

export default function RichTextEditor({
  defaultValue,
  onChange,
  readOnly,
  autoFocus,
  ...props
}) {
  const ref = useRef();

  // Added in as this causes spacing issues when using HTML rather than the Quill Delta system
  const modules = {
    clipboard: {
      matchVisual: false,
    },
  };

  useEffect(() => {
    if (autoFocus) ref.current.getEditor().focus();
  }, [ref, autoFocus]);

  return (
    <ReactQuill
      name="body"
      defaultValue={defaultValue}
      readOnly={readOnly}
      modules={modules}
      onChange={onChange}
      ref={ref}
      {...props}
    />
  );
}

RichTextEditor.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

RichTextEditor.defaultProps = {
  defaultValue: "",
  onChange: () => {},
  readOnly: false,
  autoFocus: false,
};
